import { FC } from 'react';
import { buildUrl } from '../../../../../../shared/frontend/libs/utils';

interface IEmbeddedYoutubeVideoPlaylistProps {
  className?: string;
  playListId: string;
  playListIndex?: number;
  width?: number | string;
  height?: number | string;
  highlightVideo?: boolean;
  style?: any;
}

const EmbeddedYoutubeVideoPlaylist: FC<IEmbeddedYoutubeVideoPlaylistProps> = (props) => {
  const { playListId, playListIndex, width, height, className, style, highlightVideo = true } = props;

  const src = buildUrl('https://www.youtube.com/embed', {
    listType: 'playlist',
    list: playListId,
    index: playListIndex || 0
  });

  return (
    <section
      className={className}
      style={{ width: width || 300, height: height || 185, backgroundColor: 'rgba(0, 0, 0, 0.5)', ...style }}
    >
      <iframe
        className={highlightVideo ? 'border-anim--highlight' : ''}
        frameBorder={0}
        scrolling="no"
        allowFullScreen={true}
        src={src}
        style={{ width: '100%', height: '100%' }}
      />
    </section>
  );
};

export default EmbeddedYoutubeVideoPlaylist;
